export default {
    BaseSaveToWorkspace: {
        Main: {
            cancel: '取消',
            submit: '確認',
            saveToWorkspaceLink: '正在添加，稍後請到工作空間“{link}”資料夾查看',
            title: '保存到工作空間',
        },
        FolderSelector: {
            label: '選擇文件夾',
            addWorkspace: '添加工作空間',
            searchType: {
                workspace: '搜工作空間',
                folder: '搜尋資料夾',
            },
            placeholder: '請輸入名稱',
            noData: {
                workspace: '暫無工作空間',
                folder: '暫無文件夾',
                searchFolder: '未找到對應文件夾',
                searchSpace: '未找到對應工作空間',
            },
            newFolderName: '新建文件夾',
            newWorkspaceName: '新建工作空間',
            workspaceGroupType: {
                public: '企業工作空間',
                shared: '來自分享的工作空間',
                self: '個人工作空間',
            },
            lastFlag: {
                ADD: '最近保存',
                COPY: '最近複製',
                MOVE: '最近移動',
                RELATED: '項目關聯',
            },
        },
        RangeSelector: {
            from: '從',
            to: '到',
            title: '請選擇範圍',
            selectAllLabel: '選擇所有',
            family: {
                label: '保存所有專利及其同族專利',
                types: {
                    SIMPLE: '所有專利及其簡單同族專利',
                    INPADOC: '所有專利及其INPADOC同族專利',
                    EXTEND: '所有專利及其PatSnap同族專利',
                    APNO: '所有專利及其同申請號專利',
                },
                error: '同族數據異常，請取消後重試。',
            },
            tip: '若搜索結果設置分組顯示，則範圍選擇的專利為代表專利',
            selectAllFamilyLabel: '選擇所有 {allCounts} 个同族',
            selectAllFamilyPatentCountLabel: '<span style="color: #8993A4">（{count} 件專利）</span>',
            familyLabel: '（{count} 件專利）',
            selectFamilyLabel: '選擇了 {allCounts} 個同族 <span style="color: #8993A4">（{count} 件專利）</span>',
        },
        AutoUpdate: {
            otherSettingLabel: '其它設置',
            label: '有新專利時自動更新至該資料夾',
            viewQuery: '查看檢索式',
            tip: '若資料夾已經開啟過自動收錄，則無法重複開啟收錄另一個檢索式。僅在全選專利（且不同時保存同族專利）時，可開啟自動收錄。',
            refine: '過濾',
            familylabel: '有新的族命中時自動更新至該資料夾',
            familyTip: '若資料夾內已開啟「按檢索式自動更新」，則本次設定將不生效',
        },
        PAPER: {
            RangeSelector: {
                simpleSelectLabel: '已選擇 <span class="s2w-simple-count">{count}</span> 篇文獻',
                error: {
                    invalidError: '請輸入合理的範圍',
                    overMaxCountError: '輸入的範圍數值不能超過{limit}',
                    rangeError: '單次最多可以保存{limit}條',
                },
            },
        },
        PATENT: {
            RangeSelector: {
                simpleSelectLabel: '已選擇 <span class="s2w-simple-count">{count}</span> 件專利',
                error: {
                    invalidError: '@:BaseSaveToWorkspace.PAPER.RangeSelector.error.invalidError',
                    overMaxCountError: '@:BaseSaveToWorkspace.PAPER.RangeSelector.error.overMaxCountError',
                    rangeError: '@:BaseSaveToWorkspace.PAPER.RangeSelector.error.rangeError',
                    disabledSelectAllError: '超過文件夾可保存上限{limit}',
                    familyRangeError: '單次最多保存{limit}個族',
                },
            },
        },
        VC: {
            RangeSelector: {
                simpleSelectLabel: '已選擇 <span class="s2w-simple-count">{count}</span> 條風險投資',
                error: {
                    invalidError: '@:BaseSaveToWorkspace.PAPER.RangeSelector.error.invalidError',
                    overMaxCountError: '@:BaseSaveToWorkspace.PAPER.RangeSelector.error.overMaxCountError',
                    rangeError: '單次最多可以保存{limit}條風險投資',
                },
            },
        },
        MA: {
            RangeSelector: {
                simpleSelectLabel: '已選擇 <span class="s2w-simple-count">{count}</span> 條企業兼併',
                error: {
                    invalidError: '@:BaseSaveToWorkspace.PAPER.RangeSelector.error.invalidError',
                    overMaxCountError: '@:BaseSaveToWorkspace.PAPER.RangeSelector.error.overMaxCountError',
                    rangeError: '單次最多可以保存{limit}條企業兼併',
                },
            },
        },
        MR: {
            RangeSelector: {
                simpleSelectLabel: '已選擇 <span class="s2w-simple-count">{count}</span> 條市場報告',
                error: {
                    invalidError: '@:BaseSaveToWorkspace.PAPER.RangeSelector.error.invalidError',
                    overMaxCountError: '@:BaseSaveToWorkspace.PAPER.RangeSelector.error.overMaxCountError',
                    rangeError: '單次最多可以保存{limit}條市場報告',
                },
            },
        },
        sequence: {
            selected: '已勾選',
            sequences: '條序列',
        },
    },
};
